module.exports = __webpack_public_path__ + "img/46.740f70da.jpg";